import * as React from "react";
import { useBulkTriggerSecurityEventNotification } from "security-app/hooks/useSecurityEventsAPI";
import SendNotificationModal from "security-app/components/SecurityEvents/Alerts/AlertsModals/NotificationsModal/SendNotificationModal";
import useSendEventActionTelemetry from "components/events/events/hooks/useSendEventActionTelemetry";
import useDeselectEntities from "common/hooks/useDeselectEntities";
const SendNotificationBulk = ({ eventIds, onClose, show, fromBulk }) => {
  const { triggerSecurityEventNotifications, triggeringSecurityEventNotifications } = useBulkTriggerSecurityEventNotification();
  const sendEventActionTelemetry = useSendEventActionTelemetry();
  const deselectEntities = useDeselectEntities();
  const onConfirm = async (notificationId) => {
    await triggerSecurityEventNotifications({ ids: eventIds, notificationId });
    sendEventActionTelemetry("SEND_NOTIFICATION", fromBulk);
    deselectEntities(eventIds);
    onClose();
  };
  return /* @__PURE__ */ React.createElement(
    SendNotificationModal,
    {
      confirmDisabled: triggeringSecurityEventNotifications,
      closeModal: onClose,
      onConfirm,
      show
    }
  );
};
export default SendNotificationBulk;
